import { getProfile, register } from '@/services/account';
import {
  sendSMSCode,
  signIn,
  signInSMSPhone,
  checkCaptcha,
} from '@/services/auth';
import { types } from '@/types';
import Cookies from 'js-cookie';
import errorException from '@/helpers/errorException';

export const auth = {
  async loadProfile({ commit }, payload) {
    commit(types.SET_LOADING, { loadProfile: true });
    try {
      const { theatreId } = payload;
      const user = await getProfile({ theatreId });
      commit(types.SET_USER_DATA, user);
    } catch (e) {
      errorException(e, commit, 'loadProfile');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { loadProfile: false });
    }
  },

  async signIn(
    { commit },
    { Data, Password, theatreId },
  ) {
    console.log('signIn');
    try {
      const authData = await signIn({ Data, Password });

      if (authData.AccessToken) {
        let token = authData.AccessToken;
        commit(types.SET_AUTH_TOKEN, token);
        commit(types.SET_ID_TOKEN, token);
        localStorage.setItem('widgetToken', token);

        const pz_tkn = JSON.parse(atob(token.split('.')[1])).pz_tkn || '';
        Cookies.set('i', pz_tkn);

        Cookies.set('i', pz_tkn, {
          expires: 30,
          domain: '.pzpreprod.66bit.ru',
          sameSite: 'None',
          secure: '',
        });

        Cookies.set('i', pz_tkn, {
          expires: 30,
          domain: '.premierzal.ru',
          sameSite: 'None',
          secure: '',
        });

        const user = await getProfile({ theatreId });
        commit(types.SET_USER_DATA, user);

        return { success: true };
      }
    } catch (e) {
      errorException(e, commit, 'signIn');
      return { success: false, error: e.message };
    }
  },

  async sendSMSCode({ commit }, { MobilePhone, Code, theatreId }) {
    console.log('sendSMSCode');
    try {
      const authWithSmsCodeData = await sendSMSCode({ MobilePhone, Code });

      console.log(authWithSmsCodeData, 'authWithSmsCodeData');

      if (authWithSmsCodeData.AccessToken) {
        let token = authWithSmsCodeData.AccessToken;
        commit(types.SET_AUTH_TOKEN, token);
        commit(types.SET_ID_TOKEN, token);
        localStorage.setItem('widgetToken', token);

        const pz_tkn = JSON.parse(atob(token.split('.')[1])).pz_tkn || '';

        Cookies.set('i', pz_tkn, {
          expires: 30,
          domain: '.pzpreprod.66bit.ru',
          sameSite: 'None',
          secure: '',
        });

        Cookies.set('i', pz_tkn, {
          expires: 30,
          domain: '.premierzal.ru',
          sameSite: 'None',
          secure: '',
        });

        const user = await getProfile({ theatreId });
        commit(types.SET_USER_DATA, user);

        return { success: true };
      }
    } catch (e) {
      errorException(e, commit, 'sendSMSCode');
      return { success: false, error: e.message };
    }
  },

  async signInSMSPhone({ commit }, { CrmSystemIdList, MobilePhone }) {
    console.log('signInSMSPhone');
    try {
      await signInSMSPhone({ CrmSystemIdList, MobilePhone });
    } catch (e) {
      console.log(e.message, 'e.message');
      errorException(e, commit, 'signInSMSPhone');
      return { success: false, error: e.message };
    }
  },

  async registration(
    { commit },
    {
      Password,
      CityId,
      CrmSystemIdList,
      MobilePhone,
      Email,
      FullName,
      Birthday,
      Gender
    },
  ) {
    console.log('registration');
    try {
      const registerData = await register({
        Password,
        CityId,
        CrmSystemIdList,
        MobilePhone: MobilePhone.replace(/\s|-|\(|\)/gi, ''),
        Email,
        FullName,
        Birthday: Birthday.split('.').reverse().join('-'),
        Gender,
      });

      if (registerData.Id) {
        return { success: true };
      }
    } catch (e) {
      errorException(e, commit, 'registration');
      return { success: false, error: e.message };
    }
  },

  async getStatusReCaptcha({ commit }, { token }) {
    try {
      return await checkCaptcha({ token });
    } catch (e) {
      console.log(e.message, 'e.message');
      errorException(e, commit, 'getStatusReCaptcha');
      return { success: false, error: e.message };
    }
  },
};
